import { render, staticRenderFns } from "./Phase2ActionButton.vue?vue&type=template&id=4b18e97a"
import script from "./Phase2ActionButton.vue?vue&type=script&lang=js"
export * from "./Phase2ActionButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4b18e97a')) {
      api.createRecord('4b18e97a', component.options)
    } else {
      api.reload('4b18e97a', component.options)
    }
    module.hot.accept("./Phase2ActionButton.vue?vue&type=template&id=4b18e97a", function () {
      api.rerender('4b18e97a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/phase2/Phase2ActionButton.vue"
export default component.exports